<template>
<p>{{ city }}, {{ day }} de {{ month }} de {{ year }}</p>
</template>

<script>
export default {
  name: 'DocLocalDate',
  props: {
    city: {
      required: true
    }
  },
  data () {
    return {
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      today: new Date()
    }
  },

  computed: {
    day () {
      return this.today.getDay()
    },
    month () {
      return this.monthNames[this.today.getMonth()]
    },
    year () {
      return this.today.getFullYear()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/Documents/DocLocalDate.vue